import { requestGet } from '@/common/request';

export interface listUploadParams {
  currentPage?: number;
  pageSize?: number;
}

export interface listUploadRes {
  ret: string;
  msg: string;
  data: {
    totalPage: number;
    pageSize: number;
    currentPage: number;
    totalCount: number;
    list:
      | Array<{ fileName: string; downloadUrl: string; successCount: number; failCount: number; status: number }>
      | [];
  };
}

//
export async function listUpload(params: listUploadParams): Promise<listUploadRes> {
  return await requestGet('/channelActivity/listUpload', params);
}
